import clsx from 'clsx';

type EmptyMessageProps = {
  className?: string;
  children?: React.ReactNode;
};

const EmptyMessage: React.FC<EmptyMessageProps> = ({ className, children }) => {
  return <div className={clsx(className, 'text-small italic')}>{children}</div>;
};

export default EmptyMessage;
